import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import FeatureShowcase from "@/components/FeatureShowcase";
import ComparisonSection from "@/components/ComparisonSection";
import InstallPrompt from "@/components/InstallPrompt";

const BoxTypesSection = lazy(() => import("@/components/BoxTypesSection"));
const WiringSection = lazy(() => import("@/components/WiringSection"));
const VehicleFitSection = lazy(() => import("@/components/VehicleFitSection"));
const AIChatSection = lazy(() => import("@/components/AIChatSection"));
const Footer = lazy(() => import("@/components/Footer"));

const LazyFallback = () => <div className="min-h-[200px]" aria-hidden="true" />;
LazyFallback.displayName = "LazyFallback";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <HeroSection />
      <FeatureShowcase />
      <div className="section-divider" />
      <div id="compare">
        <ComparisonSection />
      </div>
      <Suspense fallback={<LazyFallback />}>
        <div className="section-divider" />
        <div id="build">
          <BoxTypesSection />
        </div>
        <div className="section-divider" />
        <VehicleFitSection />
        <div className="section-divider" />
        <div id="wiring">
          <WiringSection />
        </div>
        <div className="section-divider" />
        <div id="ai">
          <AIChatSection />
        </div>
        <Footer />
        <InstallPrompt />
      </Suspense>
    </div>
  );
};

export default Index;
